@if (!isServer()) {
  <div id="stars"></div>
  <div id="stars2"></div>
  <div id="stars3"></div>
  <div class="content">
    <div class="image"><img src="/assets/images/404.png" /></div>
    <h3>Sorry Content could not be loaded</h3>
    <!--    <a class="button round" routerLink="/">go back home</a>-->
  </div>
}
